import { useMemo } from 'react';
const stepKeys = (step) => {
    const keys = Object.keys(step).filter((k) => k !== 'id');
    return keys;
};
const deepEqual = (a, b) => {
    if (a === b)
        return true;
    if (a == null || b == null)
        return a === b;
    if (typeof a !== typeof b)
        return false;
    if (typeof a !== 'object')
        return false;
    if (Array.isArray(a) !== Array.isArray(b))
        return false;
    if (Array.isArray(a)) {
        const arrB = b;
        if (a.length !== arrB.length)
            return false;
        return a.every((v, i) => deepEqual(v, arrB[i]));
    }
    const objA = a;
    const objB = b;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length)
        return false;
    return keysA.every((k) => Object.hasOwn(objB, k) && deepEqual(objA[k], objB[k]));
};
const useDripDiff = (a, b) => {
    return useMemo(() => {
        if (!a || !b)
            return null;
        const mapA = new Map();
        for (const s of a.steps)
            mapA.set(s.id, s);
        const mapB = new Map();
        for (const s of b.steps)
            mapB.set(s.id, s);
        const added = [];
        const removed = [];
        const changed = [];
        for (const s of b.steps) {
            if (!mapA.has(s.id)) {
                added.push(s);
            }
        }
        for (const s of a.steps) {
            if (!mapB.has(s.id)) {
                removed.push(s);
            }
        }
        for (const s of b.steps) {
            const prev = mapA.get(s.id);
            if (!prev)
                continue;
            if (deepEqual(prev, s))
                continue;
            const allKeys = new Set([...stepKeys(prev), ...stepKeys(s)]);
            const changedKeys = [];
            for (const k of allKeys) {
                if (!deepEqual(prev[k], s[k])) {
                    changedKeys.push(k);
                }
            }
            changed.push({ before: prev, after: s, changedKeys });
        }
        return { added, removed, changed };
    }, [a, b]);
};
export default useDripDiff;
